import { useQuery } from "@tanstack/react-query";
import {
  FormSubmissionDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_FORM_SUBMISSIONS } from "../domain";

import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { submissionsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_GET_PREVIOUS_SUBMISSIONS = "GET_PREVIOUS_SUBMISSION";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

type GetPreviousSubmission = {
  formId: string;
};

export const fetchPreviousSubmission = async (
  req: GetPreviousSubmission,
): Promise<FormSubmissionDto[] | undefined> => {
  const response = await submissionsApi.submissionsControllerGetPreviousSubmissions(
    req.formId,
  );

  return response.data;
};

export const useGetPreviousSubmission = (
  user: UserProfileDto | null,
  req: GetPreviousSubmission,
  enable: boolean = true,
): {
  previousSubmissions: FormSubmissionDto[] | undefined;
  previousSubmissionsEnabled: boolean;
  previousSubmissionsErro: Error | null;
  isLoadingPreviousSubmission: boolean;
  isFetchingPreviousSubmission: boolean;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { data, error, isLoading, isFetching } = useQuery<
    FormSubmissionDto[] | undefined,
    Error
  >({
    queryKey: [DOMAIN_FORM_SUBMISSIONS, ACTION_GET_PREVIOUS_SUBMISSIONS, req],
    queryFn: () => fetchPreviousSubmission(req),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    previousSubmissions: data,
    previousSubmissionsEnabled: enabled,
    previousSubmissionsErro: error,
    isLoadingPreviousSubmission: isLoading,
    isFetchingPreviousSubmission: isFetching,
  };
};
